import React from "react";
import HomeAdSwiper from "@components/swiper/HomeAdSwiper";
import { SwiperSlide } from "swiper/react";
import Image from "@components/item/Image";

import { useTheme } from "@emotion/react";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import styled from "@emotion/styled";

interface IAdSwiper {
  onClick?: () => void;
}

const ImageWrapper = styled.div({
  width: "100%",
  aspectRatio: "9 / 2",
  // overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const AdSwiper = ({ onClick }: IAdSwiper) => {
  const theme = useTheme();
  const { getAdList } = useApiRequest();
  const lang = window.localStorage.getItem("language");

  const { data: adList } = useQuery({
    queryKey: ["adList"],
    queryFn: getAdList,
  });

  const handleAdClick = (link: string) => {
    window.open(link, "_blank");
  };

  return (
    <HomeAdSwiper>
      {adList?.map((item: any) => {
        const src = item[`image_${lang}_url`] || item.image_ko_url;

        return (
          <SwiperSlide key={item.advertisement_id}>
            <ImageWrapper
              onClick={onClick ? onClick : () => handleAdClick(item.link)}>
              <Image
                src={src}
                alt="ad"
                width="100%"
                height="100%"
                fit="cover"
              />
            </ImageWrapper>
          </SwiperSlide>
        );
      })}
    </HomeAdSwiper>
  );
};

export default AdSwiper;
